import { Component, OnInit, OnDestroy, Inject, ViewChild, HostListener, NgZone } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {parsePhoneNumber, isValidPhoneNumber, PhoneNumber,} from 'libphonenumber-js';

import { AppService } from '../../app.service';
import { OrderService } from 'src/app/_services/order.service';
import { OrderItemsUtilsService } from 'src/app/order-items/order-items-util.service';
import { OrderLoyaltyService } from '../../_services/order-loyalty.service';

import { InlineKeypadComponent } from 'src/app/components/inline-keypad/inline-keypad.component';
import { LoyaltyBenefitOffersDialogComponent } from './loyalty-benefit-offers-dialog/loyalty-benefit-offers-dialog.component';
import * as _ from 'lodash';

@Component({
    selector: 'app-order-loyalty',
    templateUrl: './order-loyalty.component.html',
    styleUrl: './order-loyalty.component.scss',
    standalone: false
})
export class OrderLoyaltyComponent implements OnInit {
	@ViewChild('regFields') public regFields;
	@ViewChild('regOptionalFields') public regOptionalFields;
	@ViewChild('loginKeypad', { static: false }) public loginKeypad: InlineKeypadComponent;
	@ViewChild('pasteTarget')

	prevDialogPosition;
	$storage;
	wizardStep = 0;
	stepsMap = {
		'clubs': 0,
		'login': 1,
		'login_auth': 2,
		'terms_missing': 3,
		'account_update': 4,
		'requiered': 5,
		'account': 6,
		'points': 7
	}
	stepsMapIndex = ['clubs', 'login', 'login_auth', 'terms_missing', 'account_update', 'requiered', 'account', 'points'];

	ui: any;
	info: any;
	title: string;
	decimalFormat: string = '0.0-0';
	terms: any = {};
	requiereInvitation: boolean = false;

	@HostListener('document:paste', ['$event'])
	handlePaste(event: ClipboardEvent) {
		let clipboardData = event.clipboardData;
		let pastedText: string = clipboardData.getData('text');
		if (this.wizardStep == this.stepsMap.login && !isNaN(Number(pastedText)) && pastedText.length >= 4 && pastedText.length <= 16) {
			this.ui.connectValue = pastedText;
			this.ui.connectValid = true;
		}
	}

	constructor(
		public dialogRef: MatDialogRef<OrderLoyaltyComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public dialog: MatDialog,
		public appService: AppService,
		public orderService: OrderService,
		public orderUtils: OrderItemsUtilsService,
		public loyaltyService: OrderLoyaltyService
	) {
		this.$storage = this.orderService.$storage;

		let phone = '';
		try {
			let tel = localStorage.getItem('c_phone');
			if (tel.includes('+') && this.appService.region == 'IL') {
				let numberInstance: PhoneNumber = parsePhoneNumber(tel);
				phone = numberInstance.nationalNumber;
				if (phone.length < 10) phone = `0${phone}`;
			}
		} catch (e) {
		}

		if (['US', 'AU'].includes(this.appService.region)) this.decimalFormat = '0.2-2';
		this.ui = {
			//simulateLogin: this.appService.appConfig.isLocal,
			connectOptions: {
				type: 'code',
				minLength: 4,
				maxLength: 20,
				showApply: false,
				showValue: false,
				amount: phone,
				amountText: phone
			},
			auth_connectOptions: {
				type: 'code',
				minLength: 4,
				maxLength: 20,
				showApply: false,
				showValue: false,
				amountText: ''
			},
			pointsOptions: {
				enableDecimals: false
			},
			connectValue: phone,
			connectValid: phone && phone.length > 4,

			authValue: '',
			authValid: false
		}
	}

	setWizardStep(step) {
		this.wizardStep = step;
	}

	startFinished;
	ngOnInit() {
		if (this.ui.simulateLogin) {
			//this.ui.connectValue = '0524402515';
			//this.ui.connectValue = '0526666666';
			//this.ui.connectValue = '0546414171';
			this.ui.connectValue = '0523248068 ';
			this.ui.connectValid = true;
		}

		setTimeout(() => { this.startFinished = true; }, 600)

		if (this.loyaltyService.loyaltyData) {//customer already loaded
			this.prepareInfo();


			if (this.loyaltyService.loyaltyData.isRegister) {
				let manualBenefit = _.get(this.loyaltyService.loyaltyMember, '$manualBenefits[0]');
				if (!this.benefits && !manualBenefit) this.ui.showRequiered = true;
			} else {
				this.ui.showRequiered = this.loyaltyService.loyaltyMember.requiereOffers;
			}

			if (this.ui.showRequiered && !this.loyaltyService.loyaltyMember.hasBenefits) {
				this.setWizardStep(this.stepsMap.requiered);
			} else {
				this.setWizardStep(this.stepsMap.account);
				if (this.data.mode == 'points') {
					this.setWizardStep(this.stepsMap.points);
					let pointsBalance = this.loyaltyService.loyaltyData.pontsBalance;
					let remainningPayment = this.$storage.order.grandTotalBeforeTax;

					//let pointsUSED = _.get(this.loyaltyService.loyaltyData, 'pointsUsed', null);
					let pointsUSED = _.get(this.data, 'pointsUsed', 0);
					/*if (pointsUSED) {
						remainningPayment += pointsUSED;
						if (['US', 'AU'].includes(this.appService.region)) remainningPayment = _.floor(remainningPayment, 2);
					}*/

					this.ui.pointsOptions = {
						amount: pointsUSED,
						amountText: pointsUSED ? String(pointsUSED) : '',
						invalid: isNaN(pointsUSED),
						remainningPayment: remainningPayment,
						pointsBalance: pointsBalance,
						maxVal: Math.min(remainningPayment, pointsBalance),
						enableDecimals: ['US', 'AU'].includes(this.appService.region)
					}
				}
			}
		} else if (this.$storage.loyaltyClubs[1]) {
			this.setWizardStep(this.stepsMap.clubs);
		} else {
			this.selectClub(this.$storage.loyaltyClubs[0]);
		}
		this.getTitle();
	}

	selectClubTimeout;
	selectClub(club) {
		if (!this.startFinished) {
			delete this.selectClubTimeout;
			this.selectClubTimeout = setTimeout(() => { this.selectClub(club) }, 100);
			return;
		}
		this.$storage.loyaltyClub = club;
		this.setWizardStep(this.stepsMap.login);
		this.getTitle();
		if (this.ui.simulateLogin) {
			this.getCustomer();
			return;
		}
	}

	loadingCustomer: boolean;

	authCustomer() {
		return this.getCustomer(this.ui.authValue);
	}

	getCustomer(pincode?, isResend?) {
		this.loadingCustomer = true;
		let phone = this.ui.connectValue;
		this.loyaltyService.getCustomer(this.$storage, this.$storage.loyaltyClub, phone, pincode).then(res => {
			this.prepareInfo();

			// Enable to test requiere terms
			//if (this.appService.appConfig.isLocal) {_.set(this.loyaltyService, 'customer.isDisplayTermsLinkIndication', true);}

			if (this.loyaltyService.customer?.isDisplayTermsLinkIndication && this.$storage.loyaltyClub.regInfo?.termsFile) {
				this.registerFields = _.pick(this.loyaltyService.customer, ['firstName', 'lastName', 'email', 'zehut', 'birthDate', 'anniversary']);
				this.setWizardStep(this.stepsMap.terms_missing);
			} else {
				if (this.loyaltyService.loyaltyMember.requiereOffers && !this.loyaltyService.loyaltyMember.hasBenefits) {
					this.setWizardStep(this.stepsMap.requiered);
				} else {
					this.setWizardStep(this.stepsMap.account);
				}
			}
			this.getTitle();
		}).catch(err => {
			let message = '_LOYALTY.member_not_found';
			if (err.type) message = err.message;
			switch (err.Key) {
				case "auth_otpSent":
					if (this.ui.simulateLogin) {
						this.getCustomer('0000');
						return;
					}
					this.setWizardStep(this.stepsMap.login_auth);
					this.getTitle();
					return;
				case "LoyaltyProviderError_InternalGetCustomer": ;
				case "InvalidPinCode":
					if (this.wizardStep == this.stepsMap.login_auth) {
						message = this.appService.translate("_LOYALTY.auth_verification_failed");
						this.clearAuth();
						break;
					}
				case "VoucherAlreadyUsed":
					message = this.appService.translate("_LOYALTY.error_voucher_redeemed");
					break;
				case "CannotCreateNewPinCode":
					message = err.Message;
					break;
				case "CustomerMustCompleteTheRegistration":
					//message = "_LOYALTY.CustomerMustCompleteTheRegistration"
					this.appService.alert({ content: "_LOYALTY.CustomerMustCompleteTheRegistration", width: 700 });
					this.clearKeyChange();
					return;
				case "RenewIsForbidden":
					this.appService.alert({ content: this.appService.translate("_LOYALTY.error_renew_forbidden") }).then(() => {
						this.signOut();
					});
					return;
				case "customerNotFound":
					let isPhone = phone.length == 10 && phone.indexOf('05') == 0;
					if (isPhone) {
						if (!this.$storage.loyaltyClub.disableRegistration) {
							if (isPhone) {
								this.register(phone);
								return;
							}
						} else if (this.$storage.loyaltyClub.wasEnabledRegistration) {
							message = '_LOYALTY_REG.missing_offers_reg_error';
						}
					}
					break;
			}

			this.appService.alert({ content: message});
		}).then(res => {
			this.loadingCustomer = false;
		});
	}
	clearAuth() {
		this.ui.loadingAuth = true;
		this.ui.auth_connectOptions.amountText = '';
		this.ui.authValue = '';
		this.ui.authValid = false
		setTimeout(() => { this.ui.loadingAuth = false; }, 0);
	}
	authResend() {
		this.clearAuth();
		this.getCustomer(undefined, true);
	}

	onPhoneAlphaNumClick() {
		//TODO: implement onPhoneAlphaNumClick
		/*let dialogRef = this.dialog.open(AlphaNumericPadDialogComponent, {
			backdropClass: 'kiosk-darker-dialog-backdrop',
			panelClass: ['kiosk-loyalty-dialog'],
			disableClose: true,
			closeOnNavigation: false,
			minWidth: 800,
			autoFocus: false,
			data: {
				source: { value: this.ui.connectValue || '' },
				title: '_LOYALTY.enter_code_with_letters'
			}
		});
		dialogRef.afterClosed().subscribe(result => {
			if (!result) return;
			this.ui.connectOptions.amount = '';
			this.ui.connectOptions.amountText = '';

			this.ui.connectValue = result;
			this.ui.connectValid = true;

			this.getCustomer();
		});*/
	}

	onPhoneKeyChange(val) {
		if (!val) return;
		let n = val.amountText.length;
		this.ui.connectValue = val.amountText;
		this.ui.connectValid = n >= 4 && n <= 16;
	}
	onAuthKeyChange(val) {
		if (!val) return;
		let n = val.amountText.length;
		this.ui.authValue = val.amountText;
		this.ui.authValid = n == 4;
	}
	clearKeyChange() {
		this.ui.connectValue = "";
		this.ui.connectValid = false;
	}

	getTitle() {
		switch (this.wizardStep) {
			case this.stepsMap.clubs:
				this.title = this.appService.translate('_LOYALTY.select_club');
				break;
			case this.stepsMap.login:
				if (this.$storage.loyaltyHeaderCaption) this.title = this.$storage.loyaltyHeaderCaption;
				else {
					switch (this.$storage.config?.settings.clubMethod) {
						case "voucher":
							this.title = this.appService.translate('_LOYALTY.title_voucher', { name: this.$storage.loyaltyClub.name });
							break;
						default:
							this.title = this.appService.translate('_LOYALTY.title_club', { name: this.$storage.loyaltyClub.name });
							break;
					}
				}
				break;
			case this.stepsMap.login_auth:
				this.title = this.appService.translate('_LOYALTY.auth_title');
				break;
			case this.stepsMap.terms_missing:
				this.title = this.appService.translate('_LOYALTY_REG.terms_required_title', { name: this.loyaltyService.customer.fullName });
				break;
			case this.stepsMap.account_update:
				this.title = this.appService.translate('_LOYALTY_REG.after_reg_add_details_title', { name: this.loyaltyService.customer.fullName });
				break;
			case this.stepsMap.requiered:
				this.title = this.loyaltyService.customer.fullName; //this.appService.translate('_LOYALTY_REG.loginPayExpiredTitle', { name: this.loyaltyService.customer.fullName });
				break;
			case this.stepsMap.account:
				if (this.info.$isVoucher) {
					//this.title = this.appService.translate('_LOYALTY.greeting_voucher');
					this.title = this.appService.translate('_LOYALTY.greeting', { name: this.loyaltyService.customer.fullName });
				} else {
					this.title = this.appService.translate('_LOYALTY.greeting', { name: this.loyaltyService.customer.fullName });
				}
				break;
			case this.stepsMap.points:
				this.title = this.appService.translate('_LOYALTY.review_points');
				break;
		}
	}

	skipTerms() {
		this.signOut();
	}

	registerFields: any = {}
	updateTerms() {
		this.ui.regWarning = this.terms.acceptTerms !== true;
		this.ui.contractWarning = this.terms.readContract !== true;
		if (!this.regFields.submitForm()) return;
		if (this.ui.regWarning || this.ui.contractWarning) return;
		const payload = _.assignIn({
			IsFilledJoinForm: 1,
			IsConfirmSms: 1
		}, this.registerFields);
		this.loadingCustomer = true;
		this.loyaltyService.registerUpdate(this.$storage, this.$storage.loyaltyClub, payload).then(res => {
			delete this.loyaltyService.customer?.isDisplayTermsLinkIndication;
			if (_.get(this.$storage.loyaltyClub.regInfo, 'optionalFields[0]')) {
				this.registerOptionalFields = _.pick(this.loyaltyService.customer, ['firstName', 'lastName', 'email', 'zehut', 'birthDate', 'anniversary']);
				this.setWizardStep(this.stepsMap.account_update);
			} else if (this.loyaltyService.loyaltyMember.requiereOffers) {
				this.setWizardStep(this.stepsMap.requiered);
			} else {
				this.setWizardStep(this.stepsMap.account);
			}
		}).catch(err => {
			this.appService.alert({ content: '_LOYALTY_REG.registration_update_error' });
		}).then(res => {
			this.loadingCustomer = false;
		});
	}

	afterRegSkip() {
		this.loadingCustomer = true;
		this.loyaltyService.sendInvitation(this.$storage, this.$storage.loyaltyClub, {}).then(res => {
			this.requiereInvitation = true;
		}).catch(err => {
			console.log('sendInvitation error', err);
			//this.appService.alert({ content: message || '_LOYALTY_REG.registration_error' });
		}).then(() => {
			this.loadingCustomer = false;
			if (this.loyaltyService.loyaltyMember.requiereOffers) {
				this.setWizardStep(this.stepsMap.requiered);
			} else {
				this.setWizardStep(this.stepsMap.account);
			}
		});
	}

	registerOptionalFields: any = {}
	isRegUpdateEnabled() {
		return Object.keys(this.registerOptionalFields).length > 0
	}
	afterRegUpdate() {
		if (!this.isRegUpdateEnabled()) return;
		if (!this.regOptionalFields.submitForm()) return;
		this.loadingCustomer = true;
		this.loyaltyService.registerUpdate(this.$storage, this.$storage.loyaltyClub, this.registerOptionalFields).then(res => {
			if (this.loyaltyService.loyaltyMember.requiereOffers) {
				this.setWizardStep(this.stepsMap.requiered);
			} else {
				this.setWizardStep(this.stepsMap.account);
			}
		}).catch(err => {
			this.appService.alert({ content: '_LOYALTY_REG.registration_update_error' });
		}).then(res => {
			this.loadingCustomer = false;
		});
	}

	openRegContract() {
		//TODO: implements loyalty terms contruct
		/*let dialogRef = this.dialog.open(TermsDialogComponent, {
			width: "90vw",
			panelClass: 'rounded-dialog',
			direction: this.appService.direction,
			data: {
				title: null,
				url: this.$storage.loyaltyClub.regInfo.termsFile
			},
			autoFocus: true
		});
		dialogRef.afterClosed().subscribe(result => {
			if (result) this.ui.readContract = true;
		});*/
	}

	benefits;
	prepareInfo() {
		this.info = this.loyaltyService.loyaltyData;
		this.benefits = null;
		let benefits = _.get(this.loyaltyService.loyaltyMember, '$autoBenefits', []);
		if (benefits[0]) {
			this.benefits = benefits;
		}
	}

	onPointsChange(val) { }

	applyPoints() {
		this.dialogRef.close(this.ui.pointsOptions);
	}

	signOut() {
		this.dialogRef.close({mode:'signout'})
	}

	continue(disableCheckManualBenfits = false) {
		this.dialogRef.close({ mode: 'continue' })
	}

	close() {
		if (this.info) {
			this.dialogRef.close();
		} else {
			this.dialogRef.close();
			//this.signOut();
		}
	}

	register(phone?) {
		this.dialogRef.close({ mode: 'register', club: this.$storage.loyaltyClub, phone: phone })
	}

	// ------------------------------------------------------------------------------>
	// manual benefits
	// ------------------------------------------------------------------------------>

	selectManualBenefit(card) {
		let parsedOffers = _.get(card, 'redeemInfo.parsedOffers[0]');
		if (card.active) {
			if (parsedOffers) this.initBenefitWithOffers(card);
			else card.active = false;
		} else {
			if (card.redeemInfo?.isUnderGeneralRedeemLimit) {
				let maxActive = this.loyaltyService.loyaltyMember.$maxManualBenfits;
				if (maxActive) {
					let activeCount = this.loyaltyService.getSelectedManualBenfitsCount(this.$storage);
					if (activeCount && activeCount >= maxActive) {
						this.appService.alert({ content: this.appService.translate('_LOYALTY.select_benefits_max', { val: maxActive }) });
						return;
					}
				}
			}
			if (parsedOffers) this.initBenefitWithOffers(card);
			else card.active = true;
		}
		this.loyaltyService.getSelectedManualBenfitsCount(this.$storage);
	}

	checkManualBenefits() {
		this.loyaltyService.loyaltyMember?.$manualBenefits?.forEach(benefit => { this.getBenfitArgs(benefit) });
	}

	getBenfitArgs(benefit) {
		let parsedOffers = _.get(benefit, 'redeemInfo.parsedOffers[0]');
		if (!parsedOffers) benefit.canApply = true;
		else {

			parsedOffers = benefit.redeemInfo.parsedOffers;
			let numberOfOffersToSelect = benefit.redeemInfo.numberOfOffersToSelect;
			let totalSelected = 0;

			// check benefit offers ---------------------------------------->

			let selectedOffers = [];
			let orderBasket = this.$storage.basket.filter(offer => {
				if (!offer._reserved || offer._reserved.benefitId == benefit.id) {
					if (offer._reserved?.benefitId == benefit.id) {
						selectedOffers.push({ _bid: offer._bid, offer: offer.offer });
					}
					return true;
				}
			});

			if (benefit.active && selectedOffers.length < numberOfOffersToSelect) {
				console.log("Loyalty removed selected benefit (141)");
				benefit.active = false;
			}

			return {
				benefit,
				selectedOffers,
				numberOfOffersToSelect,
				parsedOffers,
				catalog: this.$storage.catalog,
				orderBasket,
				group: this.orderUtils.prepareUpsaleGroup({ offers: parsedOffers.map(offer => { return { offerId: offer._id, name: offer.name} }) }, this.$storage)
			};
		}
	}

	initBenefitWithOffers(benefit) {
		// TODO: implement initBenefitWithOffers
		if (benefit.active) {
			this.appService.confirm({ content: "_LOYALTY.confirmCancel_benefit", cancelText: 'no', confirmText: 'yes' }).then(() => {
				this.loyaltyService.cancelSelectedBenefit(this.$storage, benefit);
			});
			return;
		}

		let args = this.getBenfitArgs(benefit);
		let dialogRef = this.dialog.open(LoyaltyBenefitOffersDialogComponent, {
			panelClass: 'rounded-dialog-nopad',
			backdropClass: 'dialog-backdrop-darker',
			disableClose: true,
			closeOnNavigation: false,
			width: "350px",
			maxWidth: '95vw',
			autoFocus: false,
			data: args
		});
		dialogRef.afterClosed().subscribe(result => {});
	}

}
